(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nav--main"] && !Shopify.designMode) return;
  try {
    (function(){
  var toggles = document.querySelectorAll('.site-nav__toggle');
  
  // Función para abrir/cerrar
  function toggle(btn, expand){
    var id = btn.getAttribute('aria-controls'); if(!id) return;
    var open = btn.getAttribute('aria-expanded') === 'true';
    var next = typeof expand === 'boolean' ? expand : !open;
    btn.setAttribute('aria-expanded', next ? 'true' : 'false');
  }

  toggles.forEach(function(btn){
    // Al hacer click: previene el enlace y abre/cierra
    btn.addEventListener('click', function(e){ 
      e.preventDefault(); 
      toggle(btn); 
    });
    
    // Para accesibilidad (teclas Enter/Espacio)
    btn.addEventListener('keydown', function(e){
      if(e.key === 'Enter' || e.key === ' '){ 
        e.preventDefault(); 
        toggle(btn); 
      }
    });
  });

  // (Opcional) Cerrar menús si se hace click fuera
  document.addEventListener('click', function(e) {
    var nav = e.target.closest('li.site-nav--has-dropdown');
    
    toggles.forEach(function(btn) {
      // Si el click NO fue en un botón O su menú, ciérralo
      var isThisNav = btn.closest('li.site-nav--has-dropdown') === nav;
      if (!isThisNav) {
        toggle(btn, false); // Cierra los demás
      }
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
